import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import useInvoiceScanManager from 'src/hooks/useInvoiceScanManager';

const SourceCell = (props: GridCellProps) => {
  const { handleCellClick } = useInvoiceScanManager();

  const field = props.field || '';
  const value = props.dataItem[field];
  const processedByOcr = props.dataItem.ocrStatus !== null;
  const displayValue = processedByOcr ? `${value} (OCR)` : value;

  const handleClick = useCallback(() => {
    handleCellClick(props.dataItem.attachId);
  }, [handleCellClick, props.dataItem.attachId]);

  return (
    <GridCellBase {...props} rowSelectionEnabled={false} onClick={handleClick} title={displayValue}>
      {displayValue}
    </GridCellBase>
  );
};

export default SourceCell;
